import Accordion from "../../component-library/elements/accordion/accordion";
import Menu from "../../component-library/elements/menu/menu";
import SearchBox from "../../component-library/elements/search-box/search-box";
import Faq from "../../component-library/patterns/faq/faq";
import Grid from "../../component-library/patterns/grid/grid";
import SearchableList from "../../component-library/patterns/searchable-list/searchable-list";

const SELECTORS = {
  ".js-SearchBox": SearchBox,
  ".js-Grid": Grid,
  ".js-Menu": Menu,
  ".js-SearchableList": SearchableList,
  ".js-Accordion": Accordion,
  ".js-Faq": Faq,
};

export default SELECTORS;
